export default __webpack_public_path__ + "static/media/seguros3.752e3e25.png";